import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'sweetalert2/src/sweetalert2.scss';
import './App.css';

import { AuthProvider } from 'contexts/AuthContext';
import { AllRoutes } from 'routes';

const App = () => {
	return (
		<AuthProvider>
			<ToastContainer style={{ fontFamily: 'Montserrat', fontSize: '14px' }} />
			<BrowserRouter>
				<AllRoutes />
			</BrowserRouter>
		</AuthProvider>
	);
};

export default App;
